import React from 'react';
import { NAPageItemConfigType, PageItemRenderingProps } from '../ConfigTypes';
import NotApprovedViolation from '../../components/NotApprovedViolation';
import isPlatformEvidenceVisibleInView from '../../utils/isPlatformEvidenceVisibleInView';

/**
 * This is a special section reserved for violation data
 */
const ViolationPageItem = (props: PageItemRenderingProps): JSX.Element => {
  const { punishmentData } = props;
  return (
    <div data-testid='violation'>
      <NotApprovedViolation violation={punishmentData.violation} />
    </div>
  );
};

export const ViolationPageItemConfig: NAPageItemConfigType = {
  getIsVisible: isPlatformEvidenceVisibleInView,
  renderComponent: ViolationPageItem,
  configName: 'violation'
};

export default ViolationPageItemConfig;
